import { useMutation, useQueryClient } from 'react-query'
import { coreAPI } from '../coreApi'
import useUserId from './useUserId'
import { TProgramEvisitPayload } from '../types/feed'
const useSubmitEvisit = () => {
  const userId = useUserId()
  const queryClient = useQueryClient()
  const eVisit = useMutation(
    (mutationPayload: TProgramEvisitPayload) =>
      coreAPI.post(`/v1/management/users/${userId}/etermin`, mutationPayload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('userRecords')
        queryClient.invalidateQueries('userDetail')
      },
    },
  )

  return eVisit
}

export default useSubmitEvisit
